/**
 * Workflow usage history management
 * Tracks which workflows user actually used for generation (not just selected)
 */

const STORAGE_KEY = 'workflowUsageHistory';
const MAX_HISTORY_ITEMS = 20;

/**
 * Get workflow usage history from localStorage
 * Returns array of workflow IDs ordered by most recent first (max 20)
 */
export function getWorkflowUsageHistory(): string[] {
  if (typeof window === 'undefined') return [];

  try {
    const historyJson = localStorage.getItem(STORAGE_KEY);
    const history = historyJson ? JSON.parse(historyJson) : [];
    return Array.isArray(history) ? history : [];
  } catch (error) {
    console.warn('Failed to load workflow history from localStorage:', error);
    return [];
  }
}

/**
 * Save workflow to usage history (most recent first, max 20 items)
 * Call this when user actually generates with a workflow, not just selects it
 */
export function saveWorkflowToHistory(workflowId: string): void {
  if (typeof window === 'undefined' || !workflowId) return;

  try {
    const currentHistory = getWorkflowUsageHistory();

    // Remove if already exists (to move to front)
    const filteredHistory = currentHistory.filter(id => id !== workflowId);

    // Add to front, limit to MAX_HISTORY_ITEMS
    const newHistory = [workflowId, ...filteredHistory].slice(0, MAX_HISTORY_ITEMS);

    localStorage.setItem(STORAGE_KEY, JSON.stringify(newHistory));
  } catch (error) {
    console.warn('Failed to save workflow to history:', error);
  }
}

/**
 * Clear all workflow usage history
 */
export function clearWorkflowHistory(): void {
  if (typeof window === 'undefined') return;

  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.warn('Failed to clear workflow history:', error);
  }
}
